import { useQuery } from "@tanstack/react-query";
import { Modal, Table } from "react-bootstrap";
import { getToolHistory, getToolOptions, Tool } from "../../api/tooling";
import {
  ApprovalBadge,
  dateLabel,
  ErrorNotice,
  MakerBadge,
} from "./ToolingShared";

export default function ToolHistory({
  tool,
  onClose,
}: {
  tool: Tool;
  onClose: () => void;
}) {
  const history = useQuery({
    queryKey: ["tooling", "history", tool.id],
    queryFn: () => getToolHistory(tool.id),
  });
  const options = useQuery({
    queryKey: ["tooling", "options"],
    queryFn: getToolOptions,
  });
  return (
    <Modal show onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{tool.code} · Repair & development history</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ErrorNotice
          error={history.error || options.error}
          retry={() => {
            history.refetch();
            options.refetch();
          }}
        />
        {history.isLoading ? (
          <p>Loading history…</p>
        ) : (
          <Table responsive striped>
            <thead>
              <tr>
                <th>Card</th>
                <th>Issue</th>
                <th>Detail</th>
                <th>Die makers</th>
                <th>Stage</th>
                <th>Points</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {history.data?.map((card) => (
                <tr key={card.id}>
                  <td>
                    #{card.id}
                    <br />
                    <ApprovalBadge card={card} />
                  </td>
                  <td>
                    {options.data?.issues.find(
                      (o) => o.value === card.issue_type
                    )?.label || card.issue_type}
                  </td>
                  <td className="tooling-detail">{card.detail}</td>
                  <td>
                    {card.makers.map((m) => (
                      <MakerBadge key={m.id} maker={m} />
                    ))}
                  </td>
                  <td>
                    {options.data?.statuses.find((o) => o.value === card.status)
                      ?.label || card.status}
                  </td>
                  <td>{card.points}</td>
                  <td>{dateLabel(card.completed_at)}</td>
                </tr>
              ))}
              {history.data?.length === 0 && (
                <tr>
                  <td colSpan={7}>
                    No repairs or development work recorded for this tool yet.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}
